import CageWeightGrowthContainer from './CageWeightGrowthContainer';

export default function CageWeightGrowthProviderContainer() {
    return <CageWeightGrowthContainer />;
}
